export default {
  optional: 'Facultatif',
  radioCheckbox: 'Veuillez répondre à la question.',
  agreeField: 'Veuillez lire et accepter la note.',
  birthDate: {
    max: "L'âge inscrit est supérieur au maximum permis.",
    min: "L'âge inscrit est inférieur au maximum permis.",
  },
};
